import React, { Component } from 'react';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';
import ImageText from '../../subcomponents/ImageText';
import IconBlock28 from '../../subcomponents/IconBlock28';
import TextImage from '../../subcomponents/TextImage';

import banner from '../../assets/img/vector/wifi.svg';
import unify1 from '../../assets/img/software/unify1.jpg';
import unify3 from '../../assets/img/software/unify3.jpg';
import unify4 from '../../assets/img/software/unify4.jpg';
import unify6 from '../../assets/img/software/unify6.jpg';
import unify9 from '../../assets/img/software/unify9.jpg';

import unifi from '../../assets/img/brand/unifi.png';
import ubiquiti from '../../assets/img/brand/ubiquiti.png';

class PlataformaWifi extends Component {
  componentDidMount() {
    document.title = 'Plataforma WiFi - Insacom';
  }
  render() {
    const iconBlocks = [
      {
        id: 1,
        img: unify3,
        title: 'Escalabilidad 100% en la nube',
        description:
          'Permite el crecimiento sin límites bajo una misma plataforma. El software de control funciona completamente en nuestro Datacenter, por lo que no tendrás que preocuparte de mantener ni actualizar nada.'
      },
      {
        id: 2,
        img: unify4,
        title: 'Provisionamiento Ágil',
        description:
          'Los tiempos de puesta en funcionamiento se reducen gracias alprovisionamiento automático de configuraciones desde el software centralizado.'
      },
      {
        id: 3,
        img: unify6,
        title: 'Control de Visitas',
        description:
          'Sistema integrado de control de visitas, para que tus clientes o visitantes puedan acceder a lnternet, sin comprometer la interidad de la red corporativa.'
      }
    ];

    return (
      <Section asuntoContacto={'Plataforma WiFi'}>
        <SectionContainer>
          <ImageText
            image={banner}
            title="Plataforma WiFi"
            description="Controle Cientos de dispositivos de red desde una sola plataforma en la nube. Los cambios en la red nunca fueron más ágiles y rápidos!">
            <div className="d-flex">
              <div className="align-self-center p-2">
                <img src={unifi} alt="Unifi" style={{ height: '60px' }}></img>
              </div>
              <div className="align-self-center p-2">
                <img src={ubiquiti} alt="Ubiquiti" style={{ height: '70px' }}></img>
              </div>
            </div>
          </ImageText>
        </SectionContainer>
        <SectionContainer grey>
          <IconBlock28 version={1} content={iconBlocks}></IconBlock28>
        </SectionContainer>
        <SectionContainer>
          <ImageText
            image={unify9}
            title="Administración Wi-Fi Enterprise Escalable"
            description="El Software del Controlador UniFi® es ideal para clientes que poseen despliegues de alta densidad  que requieren baja latencia y un uptime alto. Un solo Controlador Unifi ejecutándose en la Cloud puede administrar multiples sitios."></ImageText>
        </SectionContainer>
        <SectionContainer grey>
          <TextImage image={unify1} title="Características avanzadas de la Plataforma">
            <ul className="list-unstyled g-font-size-13 mb-0">
              <li>
                <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                Configuración, control y monitoreo de forma intuitiva y robusta.
              </li>
              <li>
                <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                Estadísticas de uso de los recursos de la red.
              </li>
              <li>
                <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                Monitoreo en tiempo real del estado de la conexión de los dispositivos.
              </li>
            </ul>
          </TextImage>
        </SectionContainer>
      </Section>
    );
  }
}

export default PlataformaWifi;



// WEBPACK FOOTER //
// ./src/sections/ti/PlataformaWifi.js